import axios from "../../utils/axios";

const getUpdatedVideo = async (videoId, likes, unlikes) => {
    const response = await axios.patch(
        `/videos/${videoId}`,
        { likes, unlikes },
        { headers: { "content-type": "application/json; charset=UTF-8" } }
    );

    return response.data;
};

export default getUpdatedVideo;
